import * as React from "react";
import moment from "moment";
import { FieldProps } from "formik";
import { Form } from "antd";

const FormItem = Form.Item;

export const DateField: React.FC<
  FieldProps<any> & {
    prefix?: React.ReactNode;
    label?: string;
  }
> = ({
  field,
  form: { touched, errors, setFieldValue, setFieldTouched },
  label,
  ...props
}) => {
  const rawError = touched[field.name] && errors[field.name];
  const errorMsg =
    typeof rawError === "string"
      ? rawError
      : Array.isArray(rawError)
      ? rawError.join(", ")
      : rawError
      ? JSON.stringify(rawError)
      : undefined;
  
  // Convert ISO string to YYYY-MM-DD format for HTML date input
  const value = React.useMemo(() => {
    if (field.value && typeof field.value === "string" && field.value.trim() !== "") {
      const momentValue = moment(field.value);
      return momentValue.isValid() ? momentValue.format('YYYY-MM-DD') : '';
    }
    return '';
  }, [field.value]);

  const handleChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const dateValue = e.target.value;
    if (dateValue) {
      // Convert YYYY-MM-DD to ISO string
      const isoString = moment(dateValue).toISOString();
      setFieldValue(field.name, isoString);
    } else {
      setFieldValue(field.name, null);
    }
  }, [field.name, setFieldValue]);

  const handleBlur = React.useCallback(() => {
    setFieldTouched(field.name, true);
  }, [field.name, setFieldTouched]);

  // Filter out non-HTML props
  const { prefix, ...htmlProps } = props;

  return (
    <FormItem
      label={label}
      help={errorMsg}
      validateStatus={errorMsg ? "error" : undefined}
    >
      <input
        type="date"
        name={field.name}
        id={field.name}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        className="date-input-white-icon date-input-focus"
        style={{
          width: '100%',
          padding: '4px 11px',
          fontSize: '14px',
          lineHeight: '1.5715',
          color: '',
          backgroundColor: '#fff',
          // border: '1px solid #d9d9d9',
          borderRadius: '6px',
          transition: 'all 0.3s',
          colorScheme: 'dark',
          '--tw-ring-color': 'transparent'
        } as React.CSSProperties & { '--tw-ring-color': string }}
        {...htmlProps}
      />
    </FormItem>
  );
};